var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xq-menu-icon"},[_c('img',{staticClass:"xq-menu-icon-img",attrs:{"src":require(`@/assets/icons/menu/icon/${_vm.iconName || 'default'}.svg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }